import { createHttpClient } from "./http";

export class EstoqueRepository {
	constructor() {
		this.axios = createHttpClient({ timeout: 300000 });
	}

	async getEstoque(unidadeDistribuidoraId, search) {
		try {
			const params = {
				unidadeDistribuidoraId,
			};

			if (search) {
				params.search = search;
			}

			const result = await this.axios.get("ordem-producao/estoque", {
				params,
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401) throw new Error("Sessão expirada. Faça login novamente.");
			if (error.response?.status === 400) throw new Error(error.response.data.message ?? "Dados inválidos.");
			throw new Error(error.message || "Erro ao buscar estoque");
		}
	}

	async getEstoqueEntradas(unidadeDistribuidoraId, search) {
		try {
			const params = {
				unidadeDistribuidoraId,
			};

			if (search) {
				params.search = search;
			}

			const result = await this.axios.get("entrada-produto/estoque", {
				params,
				headers: {
					Authorization: `Bearer ${localStorage.getItem("access_token")}`,
				},
			});

			return result.data;
		} catch (error) {
			if (error.response?.status === 401) throw new Error("Sessão expirada. Faça login novamente.");
			if (error.response?.status === 400) throw new Error(error.response.data.message ?? "Dados inválidos.");
			throw new Error(error.message || "Erro ao buscar estoque de entradas");
		}
	}
}
